import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TooltipModule as NgxTooltipModule} from 'ngx-bootstrap/tooltip';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgxTooltipModule.forRoot(),
  ],
  exports: [
    NgxTooltipModule,
  ]
})
export class TooltipModule { }
